module.exports = __webpack_public_path__ + "img/amx-11.cbc56d2c.webp";